__turbopack_context__.v({
  "buttonCV": "index-module__jE4LoG__buttonCV",
  "buttonCVMobile": "index-module__jE4LoG__buttonCVMobile",
});
